import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Http } from '@devesharp/react/web/index';
import { useRecoilState } from 'recoil';
import {AuthAPI, AuthPasswordRecoveryAPI} from '~/api';
import { actionSetAuth } from '~/redux/modules/auth';
import { actionUpdateUser } from '~/redux/modules/user';
import {
   companyPageSelectState,
   companySelectState,
   companyShowInfoState,
   uniqueCompanyUserState,
} from '~/recoil/company-select.state';

export function useForgetPasswordPage(): any {
   const [logging, setLogging] = useState(false);
   const [dashInit, setDashInit] = useState(false);
   const [error, setError] = useState('');
   const [success, setSuccess] = useState(false);

   document.title = 'Login - XPAG Tecnologia';

   const store = useSelector<any>((store: any) => store);
   const dispatch = useDispatch();

   const [, setSellerPageSelect] = useRecoilState(companyPageSelectState);
   const [, setSellerSelect] = useRecoilState(companySelectState);
   const [, setShowInfoSeller] = useRecoilState(companyShowInfoState);
   const [, setUniqueSeller] = useRecoilState(uniqueCompanyUserState);

   useEffect(() => {
      setSellerPageSelect(null);
      setSellerSelect(null);
      setShowInfoSeller(false);
      setUniqueSeller(true);
      Http.defaults.headers.Authorization = '';
   }, []);

   function onSubmit(data: { login: string; password: string }): void {
      setLogging(true);
      
         AuthPasswordRecoveryAPI(data).subscribe(
            (response: any) => {
               setSuccess(true);
               // const { info, user } = response.data;
               // Http.defaults.headers.Authorization = `Bearer ${user.access_token}`;
               // dispatch(actionSetAuth(true, user.access_token));
               // dispatch(actionUpdateUser(user));
               // setDashInit(true);
            },
            (err: any) => {
               setError(err?.detail?.description || err?.data?.error);
               setLogging(false);
            },
         );
   }

   return {
      success,
      dashInit,
      logging,
      error,
      onSubmit,
   };
}
